import { computed, type ComputedRef, unref } from 'vue'

import { kebab } from '../utils/helpers.ts'

export function useClassName<T>(baseName: string, variations: string[] | ComputedRef<string[]>, additionalClassNames?: T): ComputedRef<(T | string)[]> {
  return computed(() => {
    const classes = new Set<T | string>()
    classes.add(baseName)

    for (const variation of unref(variations)) {
      if (variation) {
        classes.add(`${baseName}-${kebab(variation)}`)
      }
    }

    const classList = Array.from(classes)

    if (additionalClassNames) {
      classList.push(unref(additionalClassNames))
    }

    return classList
  })
}
